var React = require('react');

function DevicesProfilesIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M39 51H2H0V53V56V58H2H39V56H2V53H39V51Z","fill":"#5FD800","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 12H57V27H59V12V10H57H6H4V12V46V48H6H39V46H6V12Z","fill":"#5FD800","key":1}),React.createElement("rect",{"x":"56","y":"42","width":"11","height":"15","stroke":"#5FD800","strokeWidth":"2","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M41 29H62V41H64V29V27H62H41H39V29V56V58H41H58V56H41V29Z","fill":"#5FD800","key":3})]);
}

DevicesProfilesIcon.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = DevicesProfilesIcon;

DevicesProfilesIcon.default = DevicesProfilesIcon;
